import {
  Chip,
  Fade,
  SvgIcon,
  Theme,
  Typography,
  useTheme,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FC } from 'react';
import { MdCheck } from 'react-icons/md';
import { NavLink } from 'react-router-dom';
import { AppPages } from '../../common/routing/app-navigator';
import {
  IssuesComponentType,
  SupplyChainIssue,
  SupplyChainItemType,
} from '../supplychain-types';
import { FiMinus } from 'react-icons/fi';

const SupplyChainIssues: FC<SupplyChainIssuesProps> = ({
  label,
  counters,
  componentType,
  className,
  type,
  index,
}) => {
  const { classes, cx } = useStyles();
  const theme = useTheme();

  if (type === SupplyChainItemType.Element) {
    return <div className={className} />;
  }

  return (
    <Fade in timeout={200 * index} key={`issues-${index}`}>
      <div className={cx(classes.supplyChainIssues, className)}>
        {componentType === IssuesComponentType.Label && label && (
          <Typography
            component={label.link ? NavLink : 'p'}
            to={label.link ? label.link : ''}
            variant='body2'
            maxWidth={70}
            fontWeight={400}
            textAlign='center'>
            {label.text}
          </Typography>
        )}
        {componentType === IssuesComponentType.Checked && (
          <SvgIcon color='success'>
            <MdCheck />
          </SvgIcon>
        )}
        {componentType === IssuesComponentType.NotApplicable && <FiMinus />}
        {componentType === IssuesComponentType.Counters &&
          counters.map(({ severity, value, issuePageFilters }) => {
            const severityColor =
              theme.palette.categoryRiskColor[
                severity ? severity.toLowerCase() : 'none'
              ];
            if (!value) {
              return null;
            }
            return (
              <div key={severity}>
                <NavLink
                  to={AppPages.Issues + `?filters=${issuePageFilters}`}
                  style={{ textDecoration: 'none' }}>
                  <Chip
                    variant='outlined'
                    label={value ? value.toLocaleString() : value}
                    size='small'
                    sx={{
                      borderColor: severityColor,
                      fontSize: theme.typography.body2.fontSize,
                      fontWeight: 600,
                      borderWidth: 2,
                    }}
                    clickable
                  />
                </NavLink>
              </div>
            );
          })}
      </div>
    </Fade>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  supplyChainIssues: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
    gap: theme.spacing(1),
  },
}));

interface SupplyChainIssuesProps {
  label: SupplyChainIssue['label'];
  counters: SupplyChainIssue['counters'];
  componentType: SupplyChainIssue['componentType'];
  className: string;
  type: SupplyChainItemType;
  index: number;
}

export default SupplyChainIssues;
